<template>
  <section
    class="container"
    hidden
  >
    <img
      src="https://cdn.gelonghui.com/static/web/glh-logo.png"
      alt="GLH Logo"
    />
    <h1 class="title">
      {{ error.statusCode }}
    </h1>
    <h2 class="info">
      {{ error.message }}
    </h2>
    <nuxt-link
      class="button"
      to="/"
      v-if="error.statusCode === 404"
    >
      首页
    </nuxt-link>
  </section>
</template>
<script>
export default {
  props: ['error'],
  mounted() {
    this.$el.removeAttribute('hidden')
  }
}
</script>


<style scoped lang="less">
.container {
  min-height: 600px;
  padding: 30px 0;
  background-color: #f8f8f8;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  .title {
    margin: 30px 0;
    font-size: 5em;
    display: block;
  }
  .info {
    font-weight: 300;
    color: #9aabb1;
    margin: 30px 0;
    display: block;
  }
  .button {
    margin-top: 50px;
    display: block;
  }
}
</style>
